/**
 * Allow to received the good streamer
 * @param network
 * @param universe
 * @param bienVendu
 * @returns {`${string}_${string}`|null}
 */
export function getDiffuseur (network, universe, bienVendu) {
  if (!network) {
    return null
  }
  let diffuseurNomDeCode = network.split('_')[0].toLowerCase()
  switch (diffuseurNomDeCode) {
    case 'facebook':
      diffuseurNomDeCode = (bienVendu) ? `${diffuseurNomDeCode.toUpperCase()}_POST_${universe}_BIENS_VENDUS` : `${diffuseurNomDeCode.toUpperCase()}_POST_${universe}`
      break
    case 'google':
      diffuseurNomDeCode = (bienVendu) ? `${diffuseurNomDeCode.toUpperCase()}_MY_BUSINESS_${universe}_BIENS_VENDUS` : `${diffuseurNomDeCode.toUpperCase()}_MY_BUSINESS_${universe}`
      break
    default:
      diffuseurNomDeCode = (bienVendu) ? `${diffuseurNomDeCode.toUpperCase()}_${universe}_BIENS_VENDUS` : `${diffuseurNomDeCode.toUpperCase()}_${universe}`
  }
  return diffuseurNomDeCode
}
